import React from 'react';
import { 
  BuyerFinancialProfile, 
  sampleBuyerFinancialProfile, 
  calculateBuyerFinancialMetrics,
  formatCurrency,
  formatPercentage
} from '../types/buyerFinancialData';

export function BuyerFinancialAnalysisMinimal() {
  try {
    // Test the calculation function
    const buyerProfile = calculateBuyerFinancialMetrics(sampleBuyerFinancialProfile);
    
    return (
      <div className="py-4 px-4 sm:py-6 sm:px-6 lg:py-8 lg:px-8">
        <div className="mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Buyer Financial Profile Analysis - Minimal Test
          </h2>
          <p className="text-sm text-gray-600 mb-4">
            Testing basic data calculation and rendering without complex components.
          </p>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Key Metrics</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="p-4 bg-gray-50 rounded-lg">
              <div className="text-sm text-gray-600">Net Worth</div>
              <div className="text-xl font-bold text-gray-900">
                {formatCurrency(buyerProfile.netWorth)}
              </div>
            </div>
            
            <div className="p-4 bg-gray-50 rounded-lg">
              <div className="text-sm text-gray-600">Monthly Income</div>
              <div className="text-xl font-bold text-gray-900">
                {formatCurrency(buyerProfile.monthlyIncome)}
              </div>
            </div>
            
            <div className="p-4 bg-gray-50 rounded-lg">
              <div className="text-sm text-gray-600">Debt-to-Income Ratio</div>
              <div className="text-xl font-bold text-gray-900">
                {formatPercentage(buyerProfile.debtToIncomeRatio)}
              </div>
            </div>
            
            <div className="p-4 bg-gray-50 rounded-lg">
              <div className="text-sm text-gray-600">Liquidity Ratio</div>
              <div className="text-xl font-bold text-gray-900">
                {buyerProfile.liquidityRatio.toFixed(1)} months
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Credit Scores</h3>
          <div className="space-y-3">
            {buyerProfile.creditScores.map((score) => (
              <div key={score.bureau} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                <div>
                  <div className="font-medium text-gray-900">{score.bureau}</div>
                  <div className="text-sm text-gray-600">Updated: {new Date(score.date).toLocaleDateString()}</div>
                </div>
                <div className="text-2xl font-bold text-blue-600">
                  {score.score}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error('Error in BuyerFinancialAnalysisMinimal:', error);
    return (
      <div className="py-4 px-4 sm:py-6 sm:px-6 lg:py-8 lg:px-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-red-900 mb-2">Error Loading Component</h2>
          <p className="text-red-700 mb-4">
            There was an error loading the buyer financial analysis component.
          </p>
          <details className="text-sm text-red-600">
            <summary className="cursor-pointer">Error Details</summary>
            <pre className="mt-2 p-2 bg-red-100 rounded text-xs overflow-auto">
              {error instanceof Error ? error.message : String(error)}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}
